import React, { useState } from 'react';
import XIcon from './icons/XIcon';
import type { Language } from '../types';
import { getTranslation } from '../utils/translations';

interface ContactModalProps {
    isOpen: boolean;
    onClose: () => void;
    language?: Language;
}

const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose, language }) => {
    const t = (key: any) => getTranslation(language, key);
    const [copied, setCopied] = useState(false);
    const email = 'spokitech@gmail.com';

    if (!isOpen) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(email).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[110] p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm flex flex-col relative animate-fade-in" onClick={e => e.stopPropagation()}>
                <div className="p-6 border-b flex justify-between items-center bg-sky-50 rounded-t-2xl">
                    <h2 className="text-xl font-bold text-slate-800">{t('contact')}</h2>
                    <button onClick={onClose} className="text-slate-500 hover:text-slate-800 p-1">
                        <XIcon className="h-6 w-6" />
                    </button>
                </div>

                <div className="p-8 text-center">
                    <div className="w-16 h-16 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                        </svg>
                    </div>
                    <p className="text-slate-600 mb-6 font-medium leading-relaxed">
                        {t('contactBody')}
                    </p>
                    
                    <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 flex flex-col gap-3 group relative">
                        <span className="text-lg font-black text-slate-800 break-all select-all font-mono dir-ltr">{email}</span>
                        <button 
                            onClick={handleCopy}
                            className={`px-4 py-2 rounded-lg font-bold text-sm transition-all shadow-sm ${copied ? 'bg-green-600 text-white' : 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-100'}`}
                        >
                            {copied ? t('copied') : t('copy')}
                        </button>
                    </div>

                    <div className="mt-8">
                        <a 
                            href={`mailto:${email}`} 
                            className="inline-flex items-center gap-2 px-8 py-3 bg-sky-600 text-white font-bold rounded-xl hover:bg-sky-700 transition-all shadow-lg shadow-sky-100"
                        >
                            {t('sendEmailBtn')}
                        </a>
                    </div>
                </div>

                <div className="p-4 bg-slate-50 border-t rounded-b-2xl flex justify-center">
                    <button 
                        onClick={onClose}
                        className="text-slate-500 hover:text-slate-700 font-bold text-sm"
                    >
                        {t('close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContactModal;